import React, { useRef, useState, useEffect } from 'react';
import { useReactToPrint } from 'react-to-print';
import ReactToPrint from 'react-to-print';
import Formulario from "../../Components/print/form";
import { FiDownload, FiPrinter } from 'react-icons/fi';
import '../../Components/style/form.css';
import { getApplicationById } from '../../Components/firestore/company';
import { useParams, useNavigate } from 'react-router-dom';
import { Spin } from 'antd';

const FormularioPage = () => {
    const componentRef = useRef();
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [applicationData, setApplicationData] = useState(null);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: 'Application_Form',
    });

    useEffect(() => {
        const fetchData = async () => {
            if (!id) {
                setError('No application ID provided');
                setLoading(false);
                return;
            }

            try {
                const data = await getApplicationById(id);
                if (!data) {
                    setError('Application not found');
                    setLoading(false);
                    return;
                }
                setApplicationData(data);
                console.log(data);
            } catch (err) {
                setError('Error fetching application data');
                console.error('Error:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <Spin size="large" />
                    <p className="mt-4 text-gray-500">Loading application data...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="bg-white p-8 rounded-lg shadow-sm max-w-md w-full">
                    <div className="text-center">
                        <h2 className="text-2xl font-semibold text-gray-900 mb-2">Error</h2>
                        <p className="text-gray-500 mb-6">{error}</p>
                        <button
                            onClick={() => navigate('/admin/applications')}
                            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            Return to Applications
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl mx-auto">
                {/* Header with actions */}
                <div className="mb-6 flex items-center justify-between bg-white rounded-lg p-4 shadow-sm">
                    <div>
                        <h1 className="text-2xl font-semibold text-gray-900">Application Form</h1>
                        <p className="text-sm text-gray-500">View and download your application details</p>
                    </div>
                    <div className="flex gap-3">
                        <button
                            onClick={handlePrint}
                            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                        >
                            <FiPrinter className="mr-2 -ml-1 h-5 w-5" />
                            Print Form
                        </button>
                        <button
                            onClick={handlePrint}
                            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                        >
                            <FiDownload className="mr-2 -ml-1 h-5 w-5" />
                            Download PDF
                        </button>
                    </div>
                </div>

                {/* Document preview container */}
                <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                    {/* Document header */}
                    <div className="border-b border-gray-200 bg-gray-50 p-4 no-print">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center">
                                <img
                                    src="/nilia.webp"
                                    alt="Institute Logo"
                                    className="h-12 w-auto"
                                />
                                <div className="ml-4">
                                    <h2 className="text-lg font-semibold text-gray-900">Instituto Nilia</h2>
                                    <p className="text-sm text-gray-500">Student Application Form</p>
                                </div>
                            </div>
                            <div className="text-right">
                                <p className="text-sm text-gray-500">Reference: #{id}</p>
                                <p className="text-sm text-gray-500">{new Date().toLocaleDateString()}</p>
                            </div>
                        </div>
                    </div>

                    {/* Document content */}
                    <div className="p-6" ref={componentRef}>
                        <div className="bg-white border border-gray-200 rounded-lg">
                            <Formulario data={applicationData} />
                        </div>
                    </div>

                    {/* Document footer */}
                    <div className="border-t border-gray-200 bg-gray-50 p-4 no-print">
                        <div className="text-center text-sm text-gray-500">
                            <p>This document is automatically generated by the Instituto Nilia system.</p>
                            <p>For any queries, please contact our support team.</p>
                        </div>
                    </div>
                </div>

                {/* Additional information or instructions */}
                <div className="mt-6 bg-white rounded-lg p-4 shadow-sm no-print">
                    <h3 className="text-sm font-medium text-gray-900">Important Notes:</h3>
                    <ul className="mt-2 text-sm text-gray-500 list-disc list-inside">
                        <li>Please review all information before downloading or printing</li>
                        <li>Make sure to keep a copy of this form for your records</li>
                        <li>Submit the signed form along with required documents</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default FormularioPage;